import * as React from 'react';
import { CARD_CLASS, CARD_CONTROL_CLASS } from '../../constants';
import { ICardCountIndicatorProps } from './types';
import { Icon, Tooltip } from 'kui';
import './CardCountIndicator.scss';

export function CardCountIndicator({
    active,
    children,
    icon,
    modificator,
    tooltip,
    onClick
}: ICardCountIndicatorProps) {
    const cardCountIndicator = CARD_CLASS + '__count-indicator';
    const cardCountIconClass = CARD_CLASS + '__count-icon';
    return (
        <Tooltip
            isNoEvents
            isNoWrap
            value={tooltip}
        >
            <span
                className={`
                    ${cardCountIndicator}
                    ${modificator ? cardCountIndicator + '--' + modificator : ''}
                    ${active ? cardCountIndicator + '--active' : ''}
                    ${onClick ? cardCountIndicator + '--action' : ''}
                    ${CARD_CONTROL_CLASS}
                `}
                onClick={onClick ? onClick : null}
            >
                <Icon
                    className={cardCountIconClass}
                    size={16}
                    xlink={icon}
                />
                {children}
            </span>
        </Tooltip>
    );
}
